module.exports = __webpack_public_path__ + "static/media/iconfont.8a690490.ttf";